import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.container])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.title])
    }, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([_ctx.$style.star])
            }, "*", 2))
          : _createCommentVNode("", true),
        _hoisted_1,
        _renderSlot(_ctx.$slots, "subtitle")
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.extra])
    }, [
      _renderSlot(_ctx.$slots, "extra")
    ], 2)
  ], 2))
}